<template>
    <v-dialog persistent v-model="get_dialogMain.dialog"  :width="get_dialogMain.withWindows" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3> {{get_dialogMain.title}} </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card width="auto" tile>
            <v-form ref="form">
                <v-card-text>
                    <v-row dense>
                        <v-col cols="6">
                            <p><label class="font-weight-bold">Nombre: </label> {{model.empleado.NombreCompleto}}</p>
                        </v-col>
                        <v-col cols="6">
                            <p><label class="font-weight-bold">Usuario: </label> {{model.usuario}}</p>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                            v-model="role.rol_id"
                                label="Roles"
                                :items="get_objectsSecound"
                                :rules="fieldRequired"
                                item-text="nombre"
                                item-value="id"
                                outlined
                                dense>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-end>
                    <v-btn class="red darken-1 mr-3" dark @click="HIDDE_DIALOG_MAIN()">Cancelar</v-btn>
                    <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                    </v-layout>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  props: ['model'],
  mixins: [Validate],
  data: () => ({
    role: {}
  }),
  components: {
  },
  mounted () {
    this.getUrlRoles('empresa.roles-list')
  },
  methods: {
    ...mapActions(['urlPostServicesAction', 'urlGetServicesActionListSecound']),
    getUrlRoles (objet) {
      const router = this.get_urls[objet]
      this.urlGetServicesActionListSecound({ url: router, data: {} })
    },
    save () {
      this.role.id = this.model.id
      const router = this.get_urls['empresa.usuarios-set-rol']
      this.urlPostServicesAction({ url: router, data: this.role })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objectsSecound', 'get_object'])
  },
  watch: {
    get_urls () {
      this.getUrlRoles('POST/roles/list')
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'El usuario ha sido vinculada con el Rol'
      })
      this.cancel()
    }
  }
}
</script>

<style>

</style>
